import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class HeaderService {
	private openProfilePanelSubject = new Subject<void>();
	private openNotificationsPanelSubject = new Subject<{
		panelToOpen: 'loads' | 'carriers' | 'projects'| 'booking-assistant-automation';
	}>();

	constructor() {}

	sendOpenProfilePanelEvent() {
		this.openProfilePanelSubject.next();
	}

	getOpenProfilePanelEvent(): Observable<void> {
		return this.openProfilePanelSubject.asObservable();
	}

	sendOpenNotificationsPanelEvent({ panelToOpen }) {
		this.openNotificationsPanelSubject.next({ panelToOpen });
	}

	getOpenNotificationsPanelEvent(): Observable<{ panelToOpen: 'loads' | 'carriers' | 'projects' | 'booking-assistant-automation' }> {
		return this.openNotificationsPanelSubject.asObservable();
	}
}
